import React, { lazy, Suspense, useCallback, useLayoutEffect, useState } from 'react'

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'
import PageHeader from 'components/PageLayout/PageHeader'
import styles from './style.module.css'
import { lang } from './lang'
import SendPageSkeleton from './Skeleton'
import { SendPageLocationState } from './types'
import PageLayout from '~components/PageLayout'
import { QueryParams } from '~constants/routes'

const SendWidget = lazy(() => import('~components/SendWidget'))

function SendPage() {
    const [searchParams] = useSearchParams()
    const location = useLocation()
    const navigate = useNavigate()

    const [openCoinSelect, setOpenCoinSelect] = useState(() =>
        Boolean((location.state as SendPageLocationState | null)?.openCoinSelect)
    )
    const [openNetworkSelect, setOpenNetworkSelect] = useState(() =>
        Boolean((location.state as SendPageLocationState | null)?.openNetworkSelect)
    )
    const onCoinSelectAutoOpen = useCallback(() => setOpenCoinSelect(false), [])
    const onNetworkSelectAutoOpen = useCallback(() => setOpenNetworkSelect(false), [])

    // layout effect: clears history state before SendWidget's passive effects strip applied query params,
    // otherwise this navigate would restore them from the stale location.search
    useLayoutEffect(() => {
        if (openCoinSelect || openNetworkSelect) {
            navigate(`${location.pathname}${location.search}`, { replace: true, state: null })
        }
    }, [location.pathname, location.search, navigate, openCoinSelect, openNetworkSelect])

    const initialCurrency = searchParams.get(QueryParams.fromCurrency) || ''
    const amount = searchParams.get(QueryParams.amount) || ''
    const recipient = searchParams.get(QueryParams.recipient) || ''
    const paymentId = searchParams.get(QueryParams.paymentId) || ''
    const network = searchParams.get(QueryParams.network) || ''

    return (
        <Suspense
            fallback={
                <PageLayout
                    contentWidth="m"
                    header={<PageHeader rootPage={false} title={<FormattedHTMLMessage {...lang.title} />} />}
                >
                    <div className={styles.wrap}>
                        <SendPageSkeleton />
                    </div>
                </PageLayout>
            }
        >
            <SendWidget
                initialCurrency={initialCurrency}
                amount={amount}
                recipient={recipient}
                initialPaymentId={paymentId}
                initialNetwork={network}
                openCoinSelect={openCoinSelect}
                onCoinSelectAutoOpen={onCoinSelectAutoOpen}
                openNetworkSelect={openNetworkSelect}
                onNetworkSelectAutoOpen={onNetworkSelectAutoOpen}
            />
        </Suspense>
    )
}

export default SendPage
